"use client"

import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { ChevronDown } from "@/lib/icons"
import { E621_ORDERS, isE621Order, type E621Order } from "@/lib/e621-filter-terms"
import { useTranslations } from "next-intl"

interface E621FilterTabsProps {
  value: E621Order | null
  onChange: (value: E621Order | null) => void
}

const NEWEST = "newest"

// The e621 family's own ordering: Hot, and the best posts of a day, week, month or year (what the site's menu offers). One dropdown
// that highlights like an active pill once something other than the default newest-first feed is picked.
export function E621FilterTabs({ value, onChange }: E621FilterTabsProps) {
  const t = useTranslations("e621FilterTabs")

  return (
    <div className={SOURCE_FILTER_ROW}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={`${sourceFilterPill(value !== null)} inline-flex items-center gap-1`}>
            {t("order")}: {value ? t(value) : t("newest")}
            <ChevronDown className="h-3 w-3" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[11rem]">
          <DropdownMenuRadioGroup
            value={value ?? NEWEST}
            onValueChange={(next) => onChange(isE621Order(next) ? next : null)}
          >
            <DropdownMenuRadioItem value={NEWEST}>{t("newest")}</DropdownMenuRadioItem>
            {E621_ORDERS.map((item) => (
              <DropdownMenuRadioItem key={item.value} value={item.value}>
                {t(item.value)}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
